import * as React from "react";
import { Redirect } from "react-router-dom";
import {
    Col,
    Container,
    Button,
    OverlayTrigger,
    Tooltip,
    Dropdown,
    Form,
    Tabs,
    Tab,
    Spinner,
    ButtonGroup,
    ToggleButtonGroup,
    ToggleButton,
} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { FiChevronDown } from "react-icons/fi";
import $ from "jquery";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCircle, faCircleH, faClose, faFilePowerpoint, faFileText, faPause, faPlay } from "@fortawesome/free-solid-svg-icons";
import profile from "../../Common/Assets/Images/profile.jpg";
import { SingleSearchDropdownList } from "../../Common/Components/SingleSearchDropdownList";
import RouteLeavingGuard from "../../Common/Components/RouteLeavingGuard";
import DatePicker from "react-datepicker";
import { WorkOrder } from "../../Common/Services/WorkOrder";
import AddCommentBox from "./AddCommentBox";
import { resolve, reject } from "q";
import Dropzone from 'react-dropzone';
import { faPlus, faMinus, faPaperclip, faFile, faFileImage, faFileExcel, faFilePdf, faFileCsv, faFileWord } from "@fortawesome/free-solid-svg-icons";
import { confirmAlert } from "react-confirm-alert";
import OutsideClickHandler from 'react-outside-click-handler';
import { AnyARecord } from "dns";
import { truncate } from "fs/promises";
import Joi from "joi-browser";
import AutosizeInput from "react-input-autosize";
import { Utils } from "../../Common/Utilis";
import ScrollContainer from "react-indiana-drag-scroll";
import { Register as registersevice } from "../../Common/Services/Register";
import PDFViewer from "../Register/pdf-viewer";
import AddHistoryBox from "./AddHistoryBox";
import { IWorkOrderCommentRequestDto } from "../../Common/Contracts/IWorkOrder";
import { MyImage } from "../../Common/Components/MyImage";
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
import TextFileViewer from "./TextViewer";
import MultiSelectAssetType from "./MultiSelectAssetType";
import _ from "lodash";
import CompleteWorkOrderModal from "../Facilities/CompleteWorkOrderModal";

let routeLeavingGuard: any = null;
let docViewerFiles: any = [];
export default class WorkOrderSlideOut extends React.Component<any, any> {
    private child: any;
    private ChildComment: any;
    private childHistoryBox: any;
    private slideoutRef: any;
    private parentScroll: any;
    private btnSave: any

    private btnOpen: any
    private btnInprogress: any
    private btnOnhold: any
    private btnComplet: any
    private input: any;
    private footerchk: any;
    private scrollheight: any;
    private multySelect: any;
    private anotherRef: any;


    constructor(props: any) {
        super(props);
        this.child = React.createRef();
        this.ChildComment = React.createRef();
        this.childHistoryBox = React.createRef();
        this.slideoutRef = React.createRef();
        this.parentScroll = React.createRef();
        this.btnSave = React.createRef();
        this.btnOpen = React.createRef();
        this.btnInprogress = React.createRef();
        this.btnOnhold = React.createRef();
        this.btnComplet = React.createRef();
        this.input = React.createRef();
        this.footerchk = React.createRef();
        this.scrollheight = React.createRef();
        this.multySelect = React.createRef();
        this.anotherRef = React.createRef();

        this.state = {
            isSpinner: false,
            pageLoader: false,
            showAddAssetModal: false,
            hidValue: "Select",
            hotelName: "Select",
            isOpenViewer: false,
            defaultView: "doc-view",
            currentZoom: 1.0,
            isGearicoSettingbuttonNew: false,
            isMapped: "No",
            isExtractOption: false,
            ispdfExtract: "No",
            isextractShowbuttonNew: false,
            modalOpen: "",
            chkIds: [],
            scrollAreaHeight: 0,
            selectedChk: [],
            // tableData: [],
            // assetTypes: [],
            // assetTypesList: [],
            createEditPermission: true,
            name: this.props.parentRowData?.title || "",
            bdrValue: false,
            locationList: this.props.parentState.locationTypesList,
            // assetList: this.props.parentState.assetTypesList,
            assetList: this.props.parentState.assetTypesList.filter(asset => asset.locationID === this.props.parentRowData.locationID),
            searchText: "",
            assetTypeId: 0,
            sortingOrder: "asc",
            sortingField: "",
            parentRowData: this.props.parentRowData,
            assignToList: this.props.parentState.assignToListRightPanel,
            priorityList: [

                { id: "Low", name: "Low" },
                { id: "Medium", name: "Medium" },
                { id: "High", name: "High" },
                { id: "Urgent", name: "Urgent" },
            ],
            selectedDueDate: "",
            savedfiles: [],
            pdfviewfiles: [],
            filteredFiles: [],
            newSelectfiles: [],
            files: [],
            fileSize: 5242880,
            moreActionFileUpload1: [
                { name: "Delete", eventKey: "delete" },
                { name: "Download", eventKey: "download" }
            ],
            isStatusloder: false,
            changeValue: false,
            pathname: "",
            isRefresh: false,
            locationId: 0,
            assetId: this.props.parentRowData?.assetID,
            priorityId: "",
            assignedId: 0,
            description: "",
            errors: false,
            inputPosition: 0,
            htmlcomment: [],
            htmlHistory: [],
            descritionBox: "",
            tempLocationSlideOutStatus: this.props.parentRowData.status,
            deleteFile: "No",
            formData: {
                cardUniqueno: 0,
                gDate: null,
                approved: "",
                uniqueno: 0,
                isAttachment: "no",
                hotelID: -1,
                invoiceno: "",
                transcationDate: null,
                dueDate: null,
                endDate: null,
                accPeriod: "",
                vendorID: 0,
                vendorName: "",
                internalNotes: "",
                checkNo: "",
                transactionTotal: "",
                tenantID: 0,
                pageType: "",
                paymenttype: "",
                oprID: -1,
                entryType: "",
                accountType: "",
                isRepeat: "No",
                repeatDate: "",
                accPeriodstatus: "Active",
                concilestatus: "No",
                saletax: "",
                vendorContract: "",
                aid: 0,
                incompleteUniqueno: 0,
                series: "",
                actionType: "",
                adj: "N",
                postFix: "",
                vendorDays: "0",
                vendorStatus: "Active",
                contractStatus: "Active",
                fileCopyfromUniqueno: "0",
                fileCopyfrom: "",
                ispayment: "No",
                readyForPayment: "No",
                paymentNotes: "",
                isPaid: "Unpaid",
                groupID: 0,
                ccType: "",
                bypassTo: "",
            },
            discradAssetId: this.props.parentRowData?.assetID,           
            isOpenWorkOrderCompleteModal: false,
            isDataSaving: false,
            activeTab: "Comments",
            discardLocationId: 0, 

        };

        this.onDrop = this.onDrop.bind(this);

        this.OpenViewer = this.OpenViewer.bind(this);
        this.handleUpdatedFile = this.handleUpdatedFile.bind(this);
        this.handleincompleteFile = this.handleincompleteFile.bind(this);
        this.saveSplitFile = this.saveSplitFile.bind(this);
        this.openfileviewer = this.openfileviewer.bind(this);
    }

    static defaultProps = {
        locationDisable: false,
        assetDisable: false,
    }

    componentDidMount() {


        let orderbyFilter = _.orderBy(this.state.assetList, ['name'], ['asc']);


        let storage = JSON.parse(localStorage.getItem("hotelSelected")!);
        let storagehotelid = storage === null ? -1 : (storage.hotelID as any);
        if (this.props.parentState.workorderPermission === "No") {
            this.isStatusCheckedPermission();
        }

        this.setState({
            selectedDueDate: this.state.parentRowData?.dueDate,
            description: this.state.parentRowData?.description, assetList: orderbyFilter

        });
        this.GetUploadFileList();
        this.GetPDFViewUploadFileList();
        this.disccardChanges();
        this.slideoutRef.current.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        this.setState({ isOpenViewer: false });
        this.slideoutRef.current.addEventListener("scroll", this.handleScroll);
    }


    handleScroll = () => {
        if (this.slideoutRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = this.slideoutRef.current;
            // If user reaches the bottom of the scroll container
            if (scrollTop + clientHeight >= scrollHeight - 10) {
                // this.childHistoryBox?.checkScrollPosition();
                if (this.childHistoryBox?.checkScrollPosition) {
                    this.childHistoryBox.checkScrollPosition();
                }
            }
        }
    };
    
    isStatusCheckedPermission = () => {
        if (this.btnOpen.current != null) {
            this.btnOpen.current.disabled = true;
        }
        if (this.btnInprogress.current != null) {
            this.btnInprogress.current.disabled = true;
        }
        if (this.btnOnhold.current != null) {
            this.btnOnhold.current.disabled = true;
        }
        if (this.btnComplet.current != null) {
            this.btnComplet.current.disabled = true;
        }
    }




    componentWillUnmount() {
        window.removeEventListener("beforeunload", this.beforeunload.bind(this));
        this.slideoutRef.current.removeEventListener("scroll", this.handleScroll);
    }

    beforeunload(e: { preventDefault: () => void; returnValue: boolean }) {
        if (
            this.state.changeValue &&
            routeLeavingGuard !== "routeLeavingGuardTrue"
        ) {
            e.preventDefault();
            e.returnValue = true;
        }
    }



    handleClick = () => {
        this.setState({ bdrValue: true });
    };

    handleBlurAutoSize = () => {
        this.setState({ bdrValue: false, name: this.state.name.trimRight(), });
    };

    onFieldChange = (event, inputPosition) => {
        let value = event.target.value;
        const fieldName = event.target.name;

        if (fieldName === "name") {
            value = value?.toString()?.trimLeft();
        }

        this.setState({ [fieldName]: value, changeValue: true });
    };

    closeSlideOut = (type: String = "") => {
        if (this.props.parentState.PageType !== "workOrderDetails") {
            if (type === "OuterClickInLocation") {
                this.props?.closeworkorderSlideout(true);
            }
        } else {
            
            if(this.state.changeValue)
            {
            this.isValidateModelPoupTab(this.state.changeValue);
            }else{
                this.props?.closeWorkSlideOut(); 
            }      
        }
    }

    closeWorkorderSlideOut = () => {
        debugger;
        this.props?.closeLocationSlideOut();
    }
    enableutton = () => {
        if (this.btnOpen.current) {
            this.btnOpen.current.disabled = false;
        }

        if (this.btnInprogress.current) {
            this.btnInprogress.current.disabled = false;
        }

        if (this.btnOnhold.current) {
            this.btnOnhold.current.disabled = false;
        }

        if (this.btnComplet.current) {
            this.btnComplet.current.disabled = false;
        }

    }

    handleSelectedItem = (controlID: any, id: any) => {

        this.setState({ changeValue: true }, () => {
            if (this.props.parentState.PageType === "workOrderDetails") {
                this.props.changesOfSlideOut(true);
            }
        });
        if (controlID === 1) {

            this.setState({ assignedId: id });
        }
        if (controlID === 2) {
            this.setState({ priorityId: id });
        }
        if (controlID === 3) {
            //this.setState({ assetId: id });
        }
        if (controlID === 4) {
            this.setState({ locationId: id }, () => {
                this.changelocation(id);
            });

        }

    };

    changelocation = (id) => {
        this.setState({ assetList: [] }, () => {

            let filetr = this.props.parentState.assetTypesList.filter(asset => asset.locationID === id);
            let orderbyFilter = _.orderBy(filetr, ['name'], ['asc']);
            this.setState({ assetList: orderbyFilter }, () => {
                this.multySelect?.current?.disccardmultyChanges();
            });
        })

    }
    isValidDate = (date) => {
        if (!(date instanceof Date) || isNaN(date.getTime())) {
            return false;
        }
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        if (year < 1900 || year > 2100 || month < 1 || month > 12 || day < 1 || day > 31) {
            return false;
        }
        return true;
    };

    handleSelectDate = (date, dateType, eventType) => {
        if (this.isValidDate(date)) {
            this.setState({ selectedDueDate: date, changeValue: true, },
                () => {
                    if (this.props.parentState.PageType === "workOrderDetails") {
                        this.props.changesOfSlideOut(true);
                    }
                }
            );
        } else {
            this.setState({ selectedDueDate: date, changeValue: false });
        }
    }
    
    closeDialog = () => {
        if (this.btnComplet.current != null) {
            this.btnComplet.current.disabled = false;
        }
        this.setState({ isOpenWorkOrderCompleteModal: false })
    }

    updateWorkOrderStatus = (type: any) => {

        if (this.state.parentRowData.status === type && this.props.parentState.PageType === "workOrderDetails") {
            toast.success("Selected status already saved", {
                position: toast.POSITION.BOTTOM_RIGHT,
            });
            return;
        }
        if (this.state.tempLocationSlideOutStatus === type && this.props.parentState.PageType === "locationWorkOrder") {
            toast.success("Selected status already saved", {
                position: toast.POSITION.BOTTOM_RIGHT,
            });
            return;
        }

        if (this.state.changeValue === true && this.props.parentState.PageType === "locationWorkOrder") {
            this.isValidateModelPoupTab(this.state.changeValue);
            return;
        }


        if (type === "Open") {
            if (this.btnOpen.current != null) {
                this.btnOpen.current.disabled = true;
            }
        }
        else if (type === "In Progress") {
            if (this.btnInprogress.current != null) {
                this.btnInprogress.current.disabled = true;
            }
        }
        else if (type === "On Hold") {
            if (this.btnOnhold.current != null) {
                this.btnOnhold.current.disabled = true;
            }

        }
        else if (type === "Completed") {

            if (this.btnComplet.current != null) {
                this.setState({ isOpenWorkOrderCompleteModal: true })
                this.btnComplet.current.disabled = true;
            }
        }
        if (type !== "Completed") {
            this.saveWorkOrderStatus(type)
        }
    }
    saveWorkOrderStatus = (type :any, resolutionData?: any) => {

        let data = this.state.selectedRows;
        let storage = JSON.parse(localStorage.getItem("storage")!);
        let tenantID = storage === null ? 0 : (storage.tenantID as any);
        let deleteWorkOrder: any[] = [];
        // for (let i = 0; i < data.length; i++) {
        let newItem: any = {};
        newItem.hotelID = Number(this.state.parentRowData?.hid);
        newItem.tenantID = tenantID;
        newItem.workOrderID = Number(this.state.parentRowData.workOrderID);
        newItem.statusType = type;
        deleteWorkOrder.push(newItem);
        if (type === "Completed") {
            newItem.resolutionId = resolutionData?.resolutionId;
            newItem.notes = resolutionData?.notes
        }
        // }

        WorkOrder.UpdateeWorkOrderStatus(deleteWorkOrder)
            .then(async (result: any | null) => {
                if (result != null && result.result != null) {

                    if (result.result.messageCode === "Success") {
                        toast.success("Work Order status changed  successfully.", {
                            position: toast.POSITION.BOTTOM_RIGHT,
                        });
                        this.setState({ isOpenWorkOrderCompleteModal: false, isDataSaving: false })
                    }
                    if (this.props.parentState.PageType === "workOrderDetails") {
                        this.props.workOrderStatusUpdate(type, this.state.parentRowData.rowID);
                    }
                    if (this.props.parentState.PageType === "locationWorkOrder") {
                        this.enableutton();

                        this.setState({ tempLocationSlideOutStatus: type });

                    }
                    if (this.props.parentState.PageType === "Asset") {
                        this.enableutton();

                        this.setState({ tempLocationSlideOutStatus: type });

                    }
                    


                }
                resolve();
            })
            .catch((err) => {
                Utils.toastError(`Server Error, ${err}`, {
                });
                if (type === "Open") {
                    if (this.btnOpen.current != null) {
                        this.btnOpen.current.disabled = false;
                    }
                }
                else if (type === "In Progress") {
                    if (this.btnInprogress.current != null) {
                        this.btnInprogress.current.disabled = false;
                    }
                }
                else if (type === "On Hold") {
                    if (this.btnOnhold.current != null) {
                        this.btnOnhold.current.disabled = false;
                    }
                }
                else if (type === "Completed") {
                    this.setState({ isOpenWorkOrderCompleteModal: false, isDataSaving: false})
                    if (this.btnComplet.current != null) {
                        this.btnComplet.current.disabled = false;
                    }
                }

                reject();
            });
    }

    onDrop = (filelist: any, mode: any) => {

        let size = this.state.fileSize;//5242880//5MB
        let newfiles: any = [];
        let files: any = [];
        let isReturn = true;
        let filestext = "";
        let filesizeval = Number(Number(this.state.fileSize) / (1024 * 1024))
        filelist.forEach(element => {
            if (element.size > size) {
                filestext = filestext + element.name + ","
                isReturn = false;
            }
        })

        if (!isReturn) {
            let msg = "One or more files are greater than " + filesizeval + "MB.";
            Utils.toastError(msg, {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "InvoiceSlideout",
            });
        }
        let isInvalidFile = false;
        filelist.forEach(element => {
            if ((element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'pdf'
                || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'doc'
                || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'docx'
                || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'xls'
                || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'xlsx'
                || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'csv'
                || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'txt'
                || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'bmp'
                || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'tif'
                || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'ppt'
                || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'pptx'
                || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'rtf'
                || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'jpg'
                || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'jpeg'
                || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'png'
                || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'msg'
                || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'eml'
            ) && element.size <= size) {
                newfiles.push(element)
                files.push(element)
            } else {
                isInvalidFile = true;
            }
        });
        if (isInvalidFile && isReturn) {
            let msg = "";
            if (filelist.length === 1) {
                msg = "This file type is not supported."
            } else {
                msg = "Some files are not supported."
            }
            Utils.toastError(msg, {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "InvoiceSlideout",
            });
        }

        let newfileData = [...this.state.newSelectfiles];
        for (let i = 0; i < newfiles.length; i++) {
            newfiles[i].etype = "newfile";
            newfileData.push(newfiles[i]);
        }


        this.setState({ files, newSelectfiles: newfileData }, () => {
            if (this.props.parentState.PageType === "workOrderDetails") {
                // this.props.changesOfSlideOut(true);
            }
            if (mode === 2) {
                //this.isHandleAction();
            } else {
                if (files.length > 0) {
                    this.handleSaveFiles();
                }
            }

        })
    }


    handleSaveFiles = () => {
        this.setState({ isSpinner: true });
        let request: any = {};
        request.Title = this.state.name;
        request.hotelID = Number(this.state.parentRowData?.hid);
        request.workOrderID = Number(this.state.parentRowData?.workOrderID);
        request.locationId = Number(this.state.parentRowData.locationID);
        request.assetId = Number(this.state.parentRowData?.assetID);
        request.priorityId = this.state.parentRowData?.priorityType;
        request.assignedId = Number(this.state.parentRowData?.user_UniqueID);
        request.description = this.state.parentRowData?.description;
        let date = this.state.parentRowData?.dueDate == null ? "" : this.state.parentRowData?.dueDate;
        if (date !== "") {
            let currentDate: any = new Date();

            let date1 = new Date(this.state.parentRowData?.dueDate);


            const dateFormatted = new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit"
            }).format(date1);
            request.dueDate = dateFormatted;
        } else {
            request.dueDate = "";
        }
        let newfileData = [...this.state.newSelectfiles];


        WorkOrder.SaveWorkOrderFile(request, newfileData)
            .then(async (result: any | null) => {
                if (result !== null) {

                    if (result.saveStatus === "Success") {

                        this.GetUploadFileList();
                        this.setState({ isSpinner: false });
                        toast.success("Files saved  successfully.", {
                            position: toast.POSITION.BOTTOM_RIGHT,
                            containerId: "InvoiceSlideout",
                        });
                        this.getHistoryTab();
                        this.GetPDFViewUploadFileList();


                    }
                    else {
                        this.setState({ isSpinner: false });
                        Utils.toastError(result.message, {
                            position: toast.POSITION.BOTTOM_RIGHT,
                            containerId: "InvoiceSlideout",
                        });
                    }
                }

                resolve();
            })
            .catch((error) => {
                this.setState({ changeValue: false, isSpinner: false });
                reject();
            });

    }






    handleSave = () => {

        if (this.state.description === "") {
            Utils.toastError(`Please populate all required fields.`, {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "addGarnishment",
            });

            return;
        } else {
            this.setState({ errors: false });
        }

        if (!this.state.name) {
            let errorMessage = "Please enter Work Order Name";
            Utils.toastError(errorMessage, {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "InvoiceSlideout",
            });

            return
        }

        this.btnSave.current.disabled = true;
        let request: any = {};
        request.Title = this.state.name;
        request.hotelID = Number(this.state.parentRowData?.hid);
        request.workOrderID = Number(this.state.parentRowData?.workOrderID);
        request.locationId = this.state.locationId == 0 ? Number(this.state.parentRowData.locationID) : Number(this.state.locationId);
        request.assetId = this.state.assetId;
        request.priorityId = this.state.priorityId == "" ? this.state.parentRowData?.priorityType : this.state.priorityId;
        request.assignedId = this.state.assignedId == 0 ? Number(this.state.parentRowData?.user_UniqueID) : Number(this.state.assignedId);
        request.description = this.state.description.trim();
        if (this.state.selectedDueDate !== "") {
            let currentDate: any = new Date();

            let date1 = new Date(this.state.selectedDueDate);


            const dateFormatted = new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit"
            }).format(date1);


            // currentDate.setDate( new Date(this.state.selectedDueDate).getDate());
            // let currentdate = currentDate.getDate();
            // let currentMonth = currentDate.getMonth() + 1;
            // let currentYear = currentDate.getFullYear();
            // let tempDate = currentMonth + "/" + currentdate + "/" + currentYear;
            request.dueDate = dateFormatted;
        } else {
            request.dueDate = "";
        }

        // let newfileData = [...this.state.newSelectfiles];
        let newfileData: any = [];

        WorkOrder.SaveWorkOrderFile(request, newfileData)
            .then(async (result: any | null) => {
                if (result !== null) {
                    if (result.saveStatus === "Success") {
                        if (this.props.parentState.PageType === "workOrderDetails") {
                            toast.success("Work Order saved  successfully.", {
                                position: toast.POSITION.BOTTOM_RIGHT,
                                containerId: "InvoiceSlideout",
                            });
                            debugger;
                            //this.setState({ discradAssetId: this.state.assetId,discardLocationId:this.state.locationId });
                            // this.getHistoryTab();
                        }
                        else {
                            toast.success("Changes saved successfully.", {
                                position: toast.POSITION.BOTTOM_RIGHT,
                                containerId: "InvoiceSlideout",
                            });
                        }
                        debugger;
                        this.btnSave.current.disabled = false;
                        this.setState({ changeValue: false, discradAssetId: this.state.assetId,discardLocationId:this.state.locationId });

                        if (this.props.parentState.PageType === "workOrderDetails") {
                            // this.props.changesOfSlideOut(false);
                            //     this.props.refeshTable(this.state.parentRowData.workOrderID);
                        }
                        if (this.props.parentState.PageType === "locationWorkOrder") {
                            //  this.props.refeshTable(this.state.parentRowData.workOrderID,"saved")
                            // this.setState({parentRowData:request});

                        }

                        this.GetUploadFileList();
                    }
                    else {
                        Utils.toastError(result.message, {
                            position: toast.POSITION.BOTTOM_RIGHT,
                            containerId: "InvoiceSlideout",
                        });
                        this.setState({ isDisabled: false })
                        this.btnSave.current.disabled = false;
                    }
                }

                resolve();
            })
            .catch((error) => {
                this.btnSave.current.disabled = false;
                reject();
            });

    }
    handleCommentsSaved = () => {
        console.log("datasavetesing");
        this.getHistoryTab();
    }
    getHistoryTab = () => {
        if (this.childHistoryBox) {
            this.childHistoryBox.current?.reloadHistory();
        }
    }

    handleTabChange = (key) => {
        this.setState({activeTab: key})
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.activeTab === "History" && this.anotherRef.current) {
            this.anotherRef.current.scrollIntoView({ behavior: "auto" });
        }
    }   
    handleSelectFileUpload = (eventKey: any, file, index) => {
        if (eventKey === "delete") {
            this.setState({ deleteFile: "Yes" });
            let request: any = {};
            // request = Object.assign({}, JSON.parse(JSON.stringify(this.state.formData)));
            let masg = "";
            masg = "Are you sure you want to delete this Attachment?"
            confirmAlert({
                title: "Delete Attachment",
                message: masg,
                buttons: [
                    {
                        label: "Yes",
                        onClick: () => this.isDeleteWorkOrder(file),
                    },
                    {
                        label: "No",
                        onClick: () => reject(),
                    },
                ],
                closeOnEscape: false,
                closeOnClickOutside: false,
                overlayClassName: "delete-file-confirmation"
            });
        }
        else if (eventKey === "download") {
            this.DownloadWorkUploadFile(file);
        } else if (eventKey === "TempDelete") {
            let masg = "";
            masg = "Are you sure you want to delete this Attachment?"
            confirmAlert({
                title: "Delete Attachment",
                message: masg,
                buttons: [
                    {
                        label: "Yes",
                        onClick: () => this.isTempDeleteWorkOrder(file),
                    },
                    {
                        label: "No",
                        onClick: () => reject(),
                    },
                ],
                closeOnEscape: false,
                closeOnClickOutside: false,
            });
        }
    }

    DownloadWorkUploadFile = (file: any) => {

        WorkOrder.DownloadWorkUploadFile(file)
            .then(async (result: any | null) => {
                resolve();
            })
            .catch((error) => {
                reject();
            });
    };


    isDeleteWorkOrder = (file: any) => {
        let deleteRequest: any = {};
        deleteRequest.hotelID = Number(this.state.parentRowData?.hid);
        deleteRequest.workOrderID = Number(this.state.parentRowData.workOrderID);
        deleteRequest.filenameUniqno = file.fileUniqueNo;

        WorkOrder.DeleteWorkOrderFiles(deleteRequest)
            .then(async (result: any | null) => {
                if (result.saveStatus === "Success") {
                    toast.success(result.message, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    this.setState({ isOpenViewer: false });
                }
                this.GetUploadFileList();
                this.getHistoryTab();
                resolve();
            })
            .catch((error) => {
                reject();
            });
    }
    isTempDeleteWorkOrder = (file: any) => {
        let data = [...this.state.newSelectfiles]
        let index = data.findIndex((item) => item.etype === "newfile");
        data.splice(index, 1);
        this.setState({ newSelectfiles: data });
    }

    onFileChange = (event: any, mode) => {
        let newfiles: any = [];
        if (event.target.files.length > 0) {
            for (let i = 0; i < event.target.files.length; i++) {
                let fileRow = event.target.files[i];

                newfiles.push(fileRow)

            }
            this.onDrop(newfiles, mode);
            let fileList = document.getElementById('formControlsFile') as any
            fileList.value = "";
        }
    };


    GetUploadFileList = () => {

        let requestlist: any = {};
        requestlist.hotelID = Number(this.state.parentRowData?.hid);
        requestlist.workOrderID = Number(this.state.parentRowData.workOrderID);

        WorkOrder.GetUploadFileList(requestlist)
            .then(async (result: any | null) => {
                if (result !== null) {

                    for (let i = 0; i < result.length; i++) {
                        this["myRef" + i] = React.createRef();
                    }
                    this.setState({ savedfiles: [] }, () => {
                        this.setState({ savedfiles: result, files: [], newSelectfiles: [], isSpinner: false });
                    });
                }
                resolve();
            })
            .catch((error) => {
                reject();
            });
    };


    // hideApprovalModal = (e: any) => {
    //     // if (e.target.className !== "disable-page-controls") {
    //     //     return;
    //     // }
    //     if (this.state.changeValue) {
    //         this.isValidateModelPoupTab();
    //     }
    // }

    hideApprovalModal = (e: any, value) => {
        // debugger;
        if (e?.target?.closest(".Toastify__toast")) {
            return;
        }
        if (this.props.parentState.PageType === "locationWorkOrder" && this.state.changeValue) {
            if (value === "closebtnclick") {
                this.props.slideOutClosewithDiscardChanges(true);
                this.isValidateModelPoupTab(value);
            }
            if (value === "sideClick") {
                this.props.closeworkorderSlideout(true);
                this.isValidateModelPoupTab(value);
            }
            if (value === "sideClick" && this.state.deleteFile === "Yes") {
                this.props.slideOutClosewithDiscardChanges(false);
            }

        }
        if (this.props.parentState.PageType === "locationWorkOrder" && this.state.changeValue === false) {
            if (value === "closebtnclick") {
                this.props.closeLocationSlideOut();
            }
            if (value === "sideClick") {
                if(this.state.deleteFile === "No" && !this.state.isOpenWorkOrderCompleteModal){
                    this.props.closeworkorderSlideout(false);
                }
                if (this.state.deleteFile === "Yes") {
                    this.props.slideOutClosewithDiscardChanges(true);
                    this.setState({ deleteFile: "No" });
                }
            }
        }
        if(this.props.parentState.PageType == "Asset" && this.state.changeValue== false){
            if (value === "closebtnclick") {
                this.props.closeLocationSlideOut();
            }
            if (value === "sideClick") {
                if(this.state.deleteFile === "No" && !this.state.isOpenWorkOrderCompleteModal){
                    this.props.closeworkorderSlideout(false);
                }
                if (this.state.deleteFile === "Yes") {
                    this.props.slideOutClosewithDiscardChanges(true);
                    this.setState({ deleteFile: "No" });
                }
            }
        }
        if (this.props.parentState.PageType == "Asset" && this.state.changeValue) {
            if (value === "closebtnclick") {
                this.props.slideOutClosewithDiscardChanges(true);
                this.isValidateModelPoupTab(value);
            }
            if (value === "sideClick") {
                this.props.closeworkorderSlideout(true);
                this.isValidateModelPoupTab(value);
            }
            if (value === "sideClick" && this.state.deleteFile === "Yes") {
                this.props.slideOutClosewithDiscardChanges(false);
            }
        }
    }

    routeLeavingGuardConfirm = (childState: any) => {
        if (childState === true) {
            routeLeavingGuard = "routeLeavingGuardTrue";
        } else {
            routeLeavingGuard = null;
        }
    };



    isValidateModelPoupTab(value) {
        confirmAlert({
            title: "Unsaved confirmation",
            message:
                "You have unsaved changes on this page. Do you want to leave this page and discard your changes?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => this.isChangeUnsaved(value),
                },
                {
                    label: "No",
                    onClick: () => reject(),
                },
            ],
            closeOnEscape: false,
            closeOnClickOutside: false,
        });
    }

    // isChangeUnsaved = () => {
    //     this.setState({ changeValue: false }, () => {          
    //         this.disccardChanges();
    //     });
    // }

    isChangeUnsaved = (value) => {
        debugger;
        if (value === "sideClick") {
            this.setState({ changeValue: false }, () => {
                this.props.closeworkorderSlideout(false)
                this.disccardChanges();
            });
        }
        else {
            this.setState({ changeValue: false }, () => {
                if (this.props.parentState.PageType !== "workOrderDetails") {
                    this.props.closeLocationSlideOut();
                    }else{
                        this.closeSlideOut();
                    }
                    this.disccardChanges();
            });
        }
    }

    disccardChanges = (btnType: string = "") => {
        // debugger;
        if (this.props.parentState.PageType === "locationWorkOrder" && this.state.changeValue === true) {
            // this.props.refeshTable(this.state.parentRowData.workOrderID,"saved")
            toast.success("Changes discarded successfully")
        }

        this.setState({
            selectedDueDate: this.state.parentRowData?.dueDate, isRefresh: true, changeValue: false,
            description: this.state.parentRowData?.description,
            assetId: this.state.discradAssetId === "" ? this.state.assetId : this.state.discradAssetId,
            assetList: this.props.parentState.assetTypesList.filter(asset => asset.locationID === this.props.parentRowData.locationID),
        }, () => {
            this.setState({ isRefresh: false });
            // let data = [...this.state.newSelectfiles]
            // let filterData = data.filter((item) => item.etype === "newfile");
            // for (let i = 0; i < filterData.length; i++) {

            //     let index = data.indexOf(filterData[i]);
            //     data.splice(index, 1);
            // }


            // this.setState({ newSelectfiles: data });
            if (this.props.parentState.PageType === "workOrderDetails") {
                this.props.changesOfSlideOut(false);
            }
            this.validationOnClick(0);
            if (btnType === "discardButton") {
                this.multySelect?.current?.disccardmultyChanges();
            }
        })

        if (this.props.parentState.PageType === "workOrderDetails" && this.state.changeValue === true) {
            toast.success("Changes discarded successfully")
        }
        // this.props.changesOfSlideOut(false);
        // this.setState({ changeValue: false },()=>{
        // this.props.changesOfSlideOut(false);
        //  });
    }

    descriptionChange = (e: any) => {

        let value = e.target.value;
        this.setState({ changeValue: true, description: value }, () => {
            if (this.props.parentState.PageType === "workOrderDetails") {
                this.props.changesOfSlideOut(true);
            }
        });

        // e.target.style.height = 'auto';
        // e.target.style.height = e.target.scrollHeight + 'px';
    }

    validateConfigurationFormSchema = (isAssetNameChanged = false) => {

        // const valid = Joi.validate(
        //   this.state.description,
        //   this.FormSchema,
        //   {
        //     abortEarly: false,
        //   }
        // );

        // const newErrorObject: any = {};
        // if (valid.error) {
        //   valid.error.details.forEach((err) => {
        //     newErrorObject[err.path.join(".")] = err.message;
        //   });
        // }

        // if (this.state.errors?.title === 'Asset Name already in use. Please provide a different name.' && isAssetNameChanged) {
        //     newErrorObject["title"] = 'Asset Name already in use. Please provide a different name.';
        // }


        // if (Object.keys(newErrorObject).length === 0) {
        //   this.setState({ isFormNotValid: false });
        // } else {
        //   this.setState({ isFormNotValid: true});
        // }
        // this.setState({ errors: newErrorObject });
        // return newErrorObject;
    };

    validationOnClick = (inputPosition) => {

        if (this.state.description === "") {
            this.setState({ errors: true });
        } else {
            this.setState({ errors: false });
        }

        // this.setState({ inputPosition }, () =>
        //   this.validateConfigurationFormSchema()
        // );

    };

    scrollToBottom = () => {
        // this.parentScroll.current.scrollTo({
        //     //top: this.parentScroll.current.clientHeight,
        //     top: this.parentScroll.current.scrollHeight,
        //     behavior: 'smooth',
        // });
    }

    updatedCommentItem = () => {
        let updatedItem: any = {};
        this.setState({ isSave: true });
        updatedItem.transcationDate = new Date();
        updatedItem.vendorName = "";
        updatedItem.amountTotal = 0;
        return updatedItem;
    }

    // PDF view function all

    handleFileCheckBox = (event, files, fileNo, selectedId, chktype) => {
        this.setState({ isExtractOption: false });
        if (chktype === "bulkSelect") {
            if (!event.target.checked) {
                this.setState({ chkIds: [], selectedChk: [] });
            } else {
                const newIds = [...this.state.chkIds];
                files.forEach((element) => {
                    for (let inx = 0; inx < element.totalpage; inx++) {
                        let id = element.fileNo.toString() + "_" + inx.toString();
                        const selectedId1 = `custom_${id}`;
                        const newId = this.state.chkIds.filter((x) => x.id === selectedId1);
                        if (newId.length === 0) {
                            let item: any = {};
                            item.id = selectedId1;
                            item.fileNo = element.fileNo;
                            newIds.push(item);
                        }
                    }
                    this.setState({ chkIds: newIds });
                });
            }
        }
        else {

            if (!event.target.checked) {
                const newIds = this.state.chkIds.filter((x) => x.id !== selectedId);
                this.setState({ chkIds: newIds });
            } else {
                const newIds = [...this.state.chkIds];
                let item: any = {};
                item.id = selectedId;
                item.fileNo = fileNo;
                newIds.push(item);
                this.setState({ chkIds: newIds });
            }
        }
    };
    saveSplitFile(splitrequest, pageno, type) {
        this.setState({ isSpinner: true });
        splitrequest.hotelID = this.state.hotelValue;
        registersevice
            .saveSplitFile(splitrequest)
            .then(async (result: any | null) => {
                this.setState({ isSpinner: false });
                if (result !== null) {
                    if (result.saveStatus === "Success") {
                        this.setState({ isSave: true });
                        this.GetUploadFileList();
                    } else {
                        Utils.toastError(result.message, {
                            position: toast.POSITION.BOTTOM_RIGHT,
                            containerId: "InvoiceSlideout",
                        });
                    }
                }
                resolve();
            })
            .catch((error) => {
                this.setState({ isSpinner: false });
                reject();
            });
    }

    handleUpdatedFile() {
        return this.state.chkIds;
    }
    handleincompleteFile() {
        return this.state.incompleteFilesCopy;
    }
    GetPDFViewUploadFileList = () => {
        let requestlist: any = {};
        requestlist.hotelID = Number(this.state.parentRowData?.hid);
        requestlist.etype = 'WorkOrder';
        requestlist.uniqueNo = Number(this.state.parentRowData.workOrderID);
        requestlist.checkNo = "";
        requestlist.series = "A";
        registersevice.GetUploadFileList(requestlist)
            .then(async (result: any | null) => {
                if (result !== null) {
                    for (let i = 0; i < result.length; i++) {
                        this["myRef" + i] = React.createRef();
                    }
                    this.setState({ pdfviewfiles: [] }, () => {
                        this.setState({ pdfviewfiles: result, files: [], newSelectfiles: [], isSpinner: false });
                    });
                    console.log("pdfviewfiles1", this.state.pdfviewfiles);
                }
                resolve();
            })
            .catch((error) => {
                reject();
            });
    };
    setTotalPages = (totalpage) => {
        let isextractShow =
            this.state.filteredFiles.length === 1 && totalpage === 1 ? true : false;
        this.setState({ isextractShow, isExtractOption: false });
    };
    OpenViewer() {
        this.setState((prevState) => ({
            isOpenViewer: !prevState.isOpenViewer,
        }));
    }
    handleZoom = (event) => {
        let currZoom = this.state.currentZoom;
        let updateZoom;
        if (event === "zoomIn") {
            updateZoom = currZoom * 1.5;
        } else {
            updateZoom = currZoom / 1.5;
        }
        this.setState({ currentZoom: updateZoom });
    };
    adjustMapping = () => {
        this.setState({ isMappedShow: true, textractMap: true }, () => {
        });
    };
    extracthideBulkselect = () => {
        this.setState({ bulkSelect: false, chkIds: [], selectedChk: [] });
        for (let i = 0; i < this.state.filteredFiles.length; i++) {
            this["myRef" + i].current.hideBulkSelect();
        }
    };
    handleAllCheckbox(event) {
        for (let i = 0; i < this.state.filteredFiles.length; i++) {
            this["myRef" + i].current.handleAllCheckbox(event);
        }
    }
    isModalOpen = (type: any) => {
        this.setState({ modalOpen: type });
    };
    handleFilterInvoiceChange = (e: any) => {
        const newincompleteFile = Object.assign(
            [],
            JSON.parse(JSON.stringify(this.state.incompleteFilesCopy))
        );
        const updatedList = newincompleteFile.filter((item: any) => {
            return (
                (
                    item.createDate.toLowerCase() +
                    item.userName.toLowerCase() +
                    item.vendor.toLowerCase()
                ).indexOf(e.target.value.toLowerCase()) > -1
            );
        });
        this.setState({
            incompleteFiles: updatedList,
            filterInvoiceInput: e.target.value,
        });
    };
    handleMoveAttachmentInvoiceListModal = (type) => {
        const incompleteFiles = Object.assign(
            [],
            JSON.parse(JSON.stringify(this.state.incompleteFilesCopy))
        );
        this.setState({
            isShowAttchmntInvLstMdl: type === "show" ? true : false,
            filterInvoiceInput: "",
            incompleteFiles,
        });
    };
    DownloadBulkInvoice = (filteredFiles) => {
        if (filteredFiles && filteredFiles.length > 0) {
            const files = filteredFiles;

            files.forEach((file, index) => {
                fetch(file.fileCode, {
                    method: 'GET',
                })
                    .then((response) => {
                        if (!response.ok) {
                            throw new Error(`Failed to download file: ${file.name}`);
                        }
                        return response.blob();
                    })
                    .then((blob) => {
                        const url = window.URL.createObjectURL(new Blob([blob]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', file.name);
                        document.body.appendChild(link);
                        link.click();
                        if (link.parentNode) {
                            link.parentNode.removeChild(link);
                        }
                    })
                    .catch((error) => {
                        console.error(`Error downloading file ${file.name}:`, error);
                    });
            });
        } else {
            console.error("No files to download.");
        }
    };
    async openfileviewer(fileUniqueNo) {
        // await this.GetPDFViewUploadFileList();
        setTimeout(async () => {
            this.setState({ filteredFiles: [] })
            const filteredFiles = this.state.pdfviewfiles.filter(
                (file) => file.uniqueNo === fileUniqueNo
            );
            this.setState({ filteredFiles });
            if (fileUniqueNo != this.state.filteredFiles.uniqueNo && this.state.filteredFiles.length > 0) {
                this.OpenViewer();
            }
            this.setState({ isOpenViewer: true });
        }, 1000);
    }
    handleExport = () => {
        let request = {} as IWorkOrderCommentRequestDto;
        request.hotelid = Number(this.state.parentRowData?.hid);
        request.workOrderID = Number(this.state.parentRowData?.workOrderID);
        WorkOrder.getHistoryWorkOrder(request)
            .then(async (result: any | null) => {
                this.downloadHistory(result)

                resolve();
            })
            .catch((err) => {
                this.setState({ isworkLoader: false });
                Utils.toastError(`Server Error, ${err}`, {
                });

                reject();
            });
    }
    downloadHistory = (result) => {
        const locationName = this.state.name.replace(/[^a-zA-Z0-9]/g, ""); 
        const currentDate = new Date().toISOString().split("T")[0]; 
        const fileName = `${locationName || "Location"}_History_${currentDate}.txt`;
        const formattedData = this.formatHistoryData(result);
        const blob = new Blob([formattedData], { type: "text/plain" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(url);
        toast.success("File has been exported successfully.", {
            position: toast.POSITION.BOTTOM_RIGHT,
        });
    };
    formatHistoryData = (data) => {
        return data.map((entry) => {
            let message = "";
            switch (entry.columnName) {
                case "CreateWorkOrder":
                    message = `${entry.createBy} created Work Order ${entry.oldValue}`;
                    break;
                case "Title":
                    message = `${entry.createBy} changed Work Order name from ${entry.oldValue || "None"} to ${entry.newValue || "None"}`;
                    break;
                case "Status":
                    message = `${entry.createBy} changed status from ${entry.oldValue || "None"} to ${entry.newValue || "None"} ${entry.additionalNotes ? `- ${entry.additionalNotes}` : ""}`;
                    break;
                case "AssignedTo":
                    message = `${entry.createBy} reassigned Work Order from ${entry.oldValue} to ${entry.newValue}`;
                    break;
                case "Description":
                    message = `${entry.createBy} updated Description from ${entry.oldValue || "None"} to ${entry.newValue || "None"}`;
                    break;
                case "Location":
                    message = `${entry.createBy} changed Location of Work Order from ${entry.oldValue || "None"} to ${entry.newValue || "None"}`;
                    break;
                case "PriorityType":
                    message = `${entry.createBy} changed Priority from ${entry.oldValue || "None"} to ${entry.newValue || "None"}`;
                    break;
                case "FileAdd":
                    message = `${entry.createBy} attached ${entry.oldValue}`;
                    break;
                case "FileDelete":
                    message = `${entry.createBy} removed ${entry.oldValue}`;
                    break;
                case "Comments":
                    message = `${entry.createBy} added a comment to ${entry.oldValue}`;
                    break;
                case "AssetRemoved":
                    let IsRemovemultiPly = entry.oldValue.split(',');
                    message = IsRemovemultiPly.length > 1 ? `${entry.createBy} removed Assets: ${entry.oldValue}` : `${entry.createBy} removed Asset: ${entry.oldValue}`;
                    break;
                case "AssetAdded":
                    let IsmultiPly = entry.oldValue.split(',');
                    message = IsmultiPly.length > 1 ? `${entry.createBy} added Assets: ${entry.oldValue}` : `${entry.createBy} added Asset: ${entry.oldValue}`;
                    break;
                case "AssetLocationchange":
                    message = `${entry.createBy} changed Location of Asset ${entry.additionalNotes || "None"} from ${entry.oldValue || "None"} to ${entry.newValue || "None"}`;
                    break;
                default:
                    message = `${entry.createBy} changed ${entry.columnName} from ${entry.oldValue || "None"} to ${entry.newValue || "None"}`;
                    break;
            }
            return `${entry.modifyedDate}  ${message}`;
        }).join("\n");
    };
    descriptionBox = () => {

    }

    assetSelectedValue = (assetSelectedValue: any) => {
        this.setState({ changeValue: true }, () => {
            if (this.props.parentState.PageType === "workOrderDetails") {
                this.props.changesOfSlideOut(true);
            }
        });
        let commaSeprated = "";
        assetSelectedValue.forEach((data: any, idx: any) => {
            commaSeprated += data.id + ",";
        });
        this.setState({ assetId: commaSeprated });
    };
    assetSelectedLocationValue = (assetSelectedValue: any) => {
        // this.setState({ changeValue: true }, () => {
        //     if (this.props.parentState.PageType === "workOrderDetails") {
        //         this.props.changesOfSlideOut(true);
        //     }
        // });
        let commaSeprated = "";
        assetSelectedValue.forEach((data: any, idx: any) => {
            commaSeprated += data.id + ",";
        });
        this.setState({ assetId: commaSeprated });
    };

    render() {
        let isPdfFile = false;
        let isImageView = false;
        const allowedExtensions = ["pdf"];
        const allowedExtensionsImage = ['jpg', 'jpeg', 'png', 'bmp'];
        let currentView = this.state.defaultView;
        for (let i = 0; i < this.state.filteredFiles.length; i++) {
            let fileDet = this.state.filteredFiles[i];
            if (allowedExtensions.includes(
                fileDet?.name
                    ?.substring(fileDet?.name.lastIndexOf(".") + 1, fileDet?.name.length)
                    ?.toLowerCase())
            ) {
                isPdfFile = true;
                break;
            }
            if (allowedExtensionsImage.includes(
                fileDet?.name
                    ?.substring(fileDet?.name.lastIndexOf(".") + 1, fileDet?.name.length)
                    ?.toLowerCase())

            ) {
                isImageView = true
                currentView = "doc-view"
                break;
            }
        }

        const savedfilesCount = this.state.filteredFiles.length;
        const allsavedfiles = this.state.filteredFiles;
        const showBulkSelect = (type) => {
            this.setState({ bulkSelect: type === "show" ? true : false });
            for (let i = 0; i < this.state.filteredFiles.length; i++) {
                this["myRef" + i].current.showBulkSelect();
            }
        };
        const checkBulkSelect = (type, totalpage) => {
            if (type === "removeAll") {
                if (
                    this.footerchk.current !== null &&
                    this.footerchk.current !== undefined
                ) {
                    this.footerchk.current.indeterminate = false;
                    this.footerchk.current.checked = false;
                }
            } else {
                if (type === "helf") {
                    this.footerchk.current.indeterminate = true;
                    this.footerchk.current.checked = false;
                } else {
                    this.footerchk.current.indeterminate = false;
                    this.footerchk.current.checked = true;
                }
            }
        };
        const handleUpdate = (newtext) => {
            toggleSwitch("doc-view");
            setTimeout(function () {
                let currentPos: any = $(`#${newtext}`).offset()?.top;
                let marginArea = currentPos - 138;
                $(".scroll-area").animate(
                    {
                        scrollTop: marginArea,
                    },
                    500
                );
            }, 500);
        };

        const handleUpdateFiles = (docFiles) => {
            docViewerFiles.push(docFiles);
        };
        const toggleSwitch = (event: any) => {
            this.setState({ defaultView: event });
            $(".scroll-area").animate(

                {
                    scrollTop: 0,
                },
                500
            );
        };

        const files1 = this.state.savedfiles.map((file, index) => (
            <>

                <li key={file.filename}>
                    <div className="d-flex align-items-center justify-content-start">
                        <div className="icon">
                            {(file?.type)?.split('/')[0] === 'image' && (
                                <FontAwesomeIcon icon={faFileImage} />
                            )}
                            {(file?.filename.substring(file?.filename.lastIndexOf(".") + 1, file?.filename.length)) === 'pdf' && (
                                <FontAwesomeIcon icon={faFilePdf} />
                            )}
                            {['png', 'jpg', 'jpeg', 'bmp'].includes(file?.filename?.substring(file?.filename.lastIndexOf(".") + 1).toLowerCase()) && (
                                <FontAwesomeIcon icon={faFileImage} />
                            )}
                            {['doc', 'docx', 'word'].includes(file?.filename?.substring(file?.filename.lastIndexOf(".") + 1).toLowerCase()) && (
                                <FontAwesomeIcon icon={faFileWord} />
                            )}
                            {['xlsx', 'xls'].includes(file?.filename?.substring(file?.filename.lastIndexOf(".") + 1).toLowerCase()) && (
                                <FontAwesomeIcon icon={faFileExcel} />
                            )}
                            {['ppt', 'pptx'].includes(file?.filename?.substring(file?.filename.lastIndexOf(".") + 1).toLowerCase()) && (
                                <FontAwesomeIcon icon={faFilePowerpoint} />
                            )}
                            {(file?.filename.substring(file?.filename.lastIndexOf(".") + 1, file?.filename.length)) === 'txt' && (
                                <FontAwesomeIcon icon={faFileText} />
                            )}
                            {(file?.filename.substring(file?.filename.lastIndexOf(".") + 1, file?.filename.length)) === 'csv' && (
                                <FontAwesomeIcon icon={faFileCsv} />
                            )}
                            {!['image', 'pdf', 'xlsx', 'xls', 'csv', 'png', 'word', 'jpg', 'jpeg', 'bmp', 'txt', 'doc', 'docx', 'ppt', 'pptx'].includes(file?.type?.split('/')[0] === 'image'
                                ? 'image'
                                : file?.filename?.substring(file?.filename.lastIndexOf(".") + 1)?.toLowerCase()
                            ) && (
                                    <FontAwesomeIcon icon={faFile} />
                                )}
                        </div>
                        <div className="file-info d-flex align-items-center"  onClick={() => this.openfileviewer(file.fileUniqueNo)}>
                            <div className="name-loader d-flex align-items-center">
                                <div className="name">
                                    <EllipsisWithTooltip placement="bottom">
                                        <div className="full-name" >{file.filename}</div>
                                    </EllipsisWithTooltip>
                                    {/* <div className="details">{file.createDate} - {file.pageno} Page</div> */}
                                </div>
                            </div>
                            <div className="formate-percentage">
                                <span className="formate d-flex justify-content-center align-items-center">{(file?.filename.substring(file?.filename.lastIndexOf(".") + 1, file?.filename.length))}</span>
                            </div>
                        </div>
                        <div className="action">

                            {/* {!this.state.bulkSelect && ( */}
                            <Dropdown className="more-action" alignRight onSelect={(event: any) => this.handleSelectFileUpload(event, file, index)}>
                                <Dropdown.Toggle className="btn-outline-primary btn btn-primary more" id="dropdown-more">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                                        <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                                        <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                                    </svg>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {this.state.moreActionFileUpload1.map(
                                        (item: any, idx: any) => (
                                            <>

                                                <Dropdown.Item
                                                    // className={}

                                                    eventKey={this.state.moreActionFileUpload1[idx].eventKey}
                                                    key={idx}
                                                    disabled={this.state.moreActionFileUpload1[idx].name === "Delete" && this.props.parentState.workorderPermission === "No"}
                                                >
                                                    {this.state.moreActionFileUpload1[idx].name}
                                                </Dropdown.Item>


                                            </>

                                        )
                                    )}
                                </Dropdown.Menu>
                            </Dropdown>
                            {/* )} */}


                        </div>
                    </div>
                </li>
            </>
        ));

        const files = this.state.newSelectfiles.map((file, index) => (


            <>
                <li key={file.name}>
                    <div className="d-flex align-items-center justify-content-start">
                        <div className="icon">
                            {(file?.type)?.split('/')[0] === 'image' && (
                                <FontAwesomeIcon icon={faFileImage} />
                            )}
                            {(file?.name.substring(file?.name.lastIndexOf(".") + 1, file?.name.length)) === 'pdf' && (
                                <FontAwesomeIcon icon={faFilePdf} />
                            )}
                            {(file?.name.substring(file?.name.lastIndexOf(".") + 1, file?.name.length)) === 'xlsx' && (
                                <FontAwesomeIcon icon={faFileExcel} />
                            )}
                            {(file?.name.substring(file?.name.lastIndexOf(".") + 1, file?.name.length)) === 'csv' && (
                                <FontAwesomeIcon icon={faFileCsv} />
                            )}
                            {(file?.name.substring(file?.name.lastIndexOf(".") + 1, file?.name.length)) === 'word' && (
                                <FontAwesomeIcon icon={faFileWord} />
                            )}
                            {(((file?.type)?.split('/')[0] !== 'image') &&
                                ((file?.name.substring(file?.name.lastIndexOf(".") + 1, file?.name.length)) !== 'pdf') &&
                                ((file?.name.substring(file?.name.lastIndexOf(".") + 1, file?.name.length)) !== 'xlsx')
                                && ((file?.name.substring(file?.name.lastIndexOf(".") + 1, file?.name.length)) !== 'csv')
                                && ((file?.name.substring(file?.name.lastIndexOf(".") + 1, file?.name.length)) !== 'word'))
                                && (
                                    <FontAwesomeIcon icon={faFile} />
                                )}
                        </div>
                        <div className="file-info d-flex align-items-center">
                            <div className="name-loader d-flex align-items-center">
                                <div className="name">
                                    <EllipsisWithTooltip placement="bottom">
                                        {/* <div className="full-name" onClick={() => { this.handlePreview(file) }}>{file.name}</div> */}
                                        <div className="full-name">{file.name}</div>
                                    </EllipsisWithTooltip>
                                </div>
                            </div>
                            <div className="formate-percentage">
                                <span className="formate d-flex justify-content-center align-items-center">
                                    {(file?.name.substring(file?.name.lastIndexOf(".") + 1, file?.name.length))}
                                </span>
                            </div>
                        </div>
                        <div className="action">
                            {/* <button className="btn-outline-primary remove-pdf more btn btn-primary" onClick={() => { this.handleSelectFileUpload("TempDelete", file, 0) }} >
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"></path></svg>
                               
                            </button> */}

                            {this.state.isSpinner && (
                                <button className="btn-outline-primary remove-pdf more btn btn-primary">
                                    <Spinner
                                        className="mr-2"
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                </button>
                            )}


                        </div>
                    </div>
                </li>
            </>
        ));

        const attachmentheader = (column: any, colIndex: any) => {
            return (
                <div className="paperClipBtn">
                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"></path></svg>
                </div>
            );
        }

        const { name } = this.state

        return (
            <>
                <RouteLeavingGuard
                    when={this.state.changeValue}
                    routeLeavingGuardConfirm={this.routeLeavingGuardConfirm}
                    shouldBlockNavigation={(location: { pathname: any }) => {

                        if (this.state.changeValue) {
                            if (location.pathname) {

                                return true;

                            }
                        }
                        return false;
                    }}
                />


                <OutsideClickHandler onOutsideClick={(e: any) => this.hideApprovalModal(e, "sideClick")}
                >
                    <div className="daily-task-slideout pos-fxd index-1000 facilities-slideout">
                        <div className="d-flex">
                            {!this.state.isOpenViewer && (
                                <div
                                    className="back-drop  viewer-panel opacity"
                                    onClick={() => this.closeSlideOut("OuterClickInLocation")}
                                ></div>
                            )}
                            {this.state.isOpenViewer && (
                                <div className="back-drop viewer-panel">
                                    <div className="header-panel update-header">
                                        <div className="d-flex justify-content-between align-items-center height-88">
                                            <div className="page-ttl">{this.state.filteredFiles[0]?.name}</div>
                                            <div className="toggle-button">
                                                {isPdfFile && (
                                                    <ButtonGroup aria-label="Basic example">
                                                        <ToggleButtonGroup
                                                            type="radio"
                                                            name="options"
                                                            value={this.state.defaultView}
                                                            onChange={toggleSwitch}
                                                        >
                                                            <ToggleButton value={"doc-view"}>
                                                                <svg
                                                                    width="20"
                                                                    height="20"
                                                                    viewBox="0 0 20 20"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path d="M10.155 12.1267C9.64082 12.1267 9.34082 12.6159 9.34082 13.2709C9.34082 13.93 9.64999 14.3959 10.16 14.3959C10.6742 14.3959 10.9692 13.9059 10.9692 13.2509C10.9692 12.6459 10.6792 12.1267 10.155 12.1267Z" />
                                                                    <path d="M11.6666 1.66663H4.99992C4.55789 1.66663 4.13397 1.84222 3.82141 2.15478C3.50885 2.46734 3.33325 2.89127 3.33325 3.33329V16.6666C3.33325 17.1087 3.50885 17.5326 3.82141 17.8451C4.13397 18.1577 4.55789 18.3333 4.99992 18.3333H14.9999C15.4419 18.3333 15.8659 18.1577 16.1784 17.8451C16.491 17.5326 16.6666 17.1087 16.6666 16.6666V6.66663L11.6666 1.66663ZM11.6666 7.49996H10.8333V3.33329L14.9999 7.49996H11.6666Z" />
                                                                </svg>
                                                            </ToggleButton>
                                                            <ToggleButton value={"grid-view"}>
                                                                <svg
                                                                    width="20"
                                                                    height="20"
                                                                    viewBox="0 0 20 20"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path d="M3.33333 9.16667H8.33333C8.55435 9.16667 8.76631 9.07887 8.92259 8.92259C9.07887 8.76631 9.16667 8.55435 9.16667 8.33333V3.33333C9.16667 3.11232 9.07887 2.90036 8.92259 2.74408C8.76631 2.5878 8.55435 2.5 8.33333 2.5H3.33333C3.11232 2.5 2.90036 2.5878 2.74408 2.74408C2.5878 2.90036 2.5 3.11232 2.5 3.33333V8.33333C2.5 8.55435 2.5878 8.76631 2.74408 8.92259C2.90036 9.07887 3.11232 9.16667 3.33333 9.16667ZM11.6667 9.16667H16.6667C16.8877 9.16667 17.0996 9.07887 17.2559 8.92259C17.4122 8.76631 17.5 8.55435 17.5 8.33333V3.33333C17.5 3.11232 17.4122 2.90036 17.2559 2.74408C17.0996 2.5878 16.8877 2.5 16.6667 2.5H11.6667C11.4457 2.5 11.2337 2.5878 11.0774 2.74408C10.9211 2.90036 10.8333 3.11232 10.8333 3.33333V8.33333C10.8333 8.55435 10.9211 8.76631 11.0774 8.92259C11.2337 9.07887 11.4457 9.16667 11.6667 9.16667ZM3.33333 17.5H8.33333C8.55435 17.5 8.76631 17.4122 8.92259 17.2559C9.07887 17.0996 9.16667 16.8877 9.16667 16.6667V11.6667C9.16667 11.4457 9.07887 11.2337 8.92259 11.0774C8.76631 10.9211 8.55435 10.8333 8.33333 10.8333H3.33333C3.11232 10.8333 2.90036 10.9211 2.74408 11.0774C2.5878 11.2337 2.5 11.4457 2.5 11.6667V16.6667C2.5 16.8877 2.5878 17.0996 2.74408 17.2559C2.90036 17.4122 3.11232 17.5 3.33333 17.5ZM11.6667 17.5H16.6667C16.8877 17.5 17.0996 17.4122 17.2559 17.2559C17.4122 17.0996 17.5 16.8877 17.5 16.6667V11.6667C17.5 11.4457 17.4122 11.2337 17.2559 11.0774C17.0996 10.9211 16.8877 10.8333 16.6667 10.8333H11.6667C11.4457 10.8333 11.2337 10.9211 11.0774 11.0774C10.9211 11.2337 10.8333 11.4457 10.8333 11.6667V16.6667C10.8333 16.8877 10.9211 17.0996 11.0774 17.2559C11.2337 17.4122 11.4457 17.5 11.6667 17.5Z" />
                                                                </svg>
                                                            </ToggleButton>
                                                        </ToggleButtonGroup>
                                                    </ButtonGroup>
                                                )}
                                            </div>
                                            <div className="action d-flex padding-update">
                                                {currentView === "doc-view" && (isImageView || isPdfFile) && (
                                                    <button
                                                        type="button"
                                                        className="btn wht-bg cross width-24"
                                                        onClick={(e) => this.handleZoom("zoomIn")}
                                                        disabled={
                                                            this.state.currentZoom >= 3.375 ? true : false
                                                        }
                                                    >
                                                        <svg
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path d="M17.2944 15.2954H16.241L15.8677 14.9354C17.4677 13.0688 18.2944 10.5221 17.841 7.81543C17.2144 4.10876 14.121 1.14876 10.3877 0.69543C4.74771 0.00209719 0.0143773 4.74876 0.694377 10.3888C1.14771 14.1221 4.10771 17.2154 7.81438 17.8421C10.521 18.2954 13.0677 17.4688 14.9344 15.8688L15.2944 16.2421V17.2954L20.9744 22.9621C21.521 23.5088 22.401 23.5088 22.9477 22.9621L22.961 22.9488C23.5077 22.4021 23.5077 21.5221 22.961 20.9754L17.2944 15.2954ZM9.29438 15.2954C5.97438 15.2954 3.29438 12.6154 3.29438 9.29543C3.29438 5.97543 5.97438 3.29543 9.29438 3.29543C12.6144 3.29543 15.2944 5.97543 15.2944 9.29543C15.2944 12.6154 12.6144 15.2954 9.29438 15.2954ZM9.29438 5.9621C8.92104 5.9621 8.62771 6.25543 8.62771 6.62876V8.62876H6.62771C6.25438 8.62876 5.96104 8.9221 5.96104 9.29543C5.96104 9.66876 6.25438 9.9621 6.62771 9.9621H8.62771V11.9621C8.62771 12.3354 8.92104 12.6288 9.29438 12.6288C9.66771 12.6288 9.96104 12.3354 9.96104 11.9621V9.9621H11.961C12.3344 9.9621 12.6277 9.66876 12.6277 9.29543C12.6277 8.9221 12.3344 8.62876 11.961 8.62876H9.96104V6.62876C9.96104 6.25543 9.66771 5.9621 9.29438 5.9621Z" />
                                                        </svg>
                                                    </button>
                                                )}
                                                {currentView === "doc-view" && (isImageView || isPdfFile) && (
                                                    <button
                                                        type="button"
                                                        className="btn wht-bg cross width-24"
                                                        onClick={(e) => this.handleZoom("zoomOut")}
                                                        disabled={
                                                            this.state.currentZoom <= 0.44 ? true : false
                                                        }
                                                    >
                                                        <svg
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path d="M17.2954 15.2954H16.2421L15.8688 14.9354C17.4688 13.0688 18.2954 10.5221 17.8421 7.81543C17.2154 4.10876 14.1221 1.14876 10.3888 0.69543C4.74876 0.00209719 0.00209719 4.74876 0.69543 10.3888C1.14876 14.1221 4.10876 17.2154 7.81543 17.8421C10.5221 18.2954 13.0688 17.4688 14.9354 15.8688L15.2954 16.2421V17.2954L20.9754 22.9621C21.5221 23.5088 22.4021 23.5088 22.9488 22.9621L22.9621 22.9488C23.5088 22.4021 23.5088 21.5221 22.9621 20.9754L17.2954 15.2954ZM9.29543 15.2954C5.97543 15.2954 3.29543 12.6154 3.29543 9.29543C3.29543 5.97543 5.97543 3.29543 9.29543 3.29543C12.6154 3.29543 15.2954 5.97543 15.2954 9.29543C15.2954 12.6154 12.6154 15.2954 9.29543 15.2954ZM6.62876 8.62876H11.9621C12.3354 8.62876 12.6288 8.9221 12.6288 9.29543C12.6288 9.66876 12.3354 9.9621 11.9621 9.9621H6.62876C6.25543 9.9621 5.9621 9.66876 5.9621 9.29543C5.9621 8.9221 6.25543 8.62876 6.62876 8.62876Z" />
                                                        </svg>
                                                    </button>
                                                )}

                                                <button
                                                    type="button"
                                                    className="btn wht-bg cross width-24"
                                                    onClick={(e) => this.DownloadBulkInvoice(this.state.filteredFiles)}
                                                >
                                                    <svg
                                                        width="20"
                                                        height="24"
                                                        viewBox="0 0 20 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path d="M16.1201 8.66675H14.0001V2.00008C14.0001 1.26675 13.4001 0.666748 12.6667 0.666748H7.33342C6.60008 0.666748 6.00008 1.26675 6.00008 2.00008V8.66675H3.88008C2.69341 8.66675 2.09341 10.1067 2.93341 10.9467L9.05342 17.0667C9.57341 17.5867 10.4134 17.5867 10.9334 17.0667L17.0534 10.9467C17.8934 10.1067 17.3067 8.66675 16.1201 8.66675ZM0.666748 22.0001C0.666748 22.7334 1.26675 23.3334 2.00008 23.3334H18.0001C18.7334 23.3334 19.3334 22.7334 19.3334 22.0001C19.3334 21.2667 18.7334 20.6667 18.0001 20.6667H2.00008C1.26675 20.6667 0.666748 21.2667 0.666748 22.0001Z" />
                                                    </svg>
                                                </button>

                                                {this.state.isGearicoSettingbuttonNew &&
                                                    this.state.isMapped.toString().toLowerCase() ===
                                                    "Yes".toString().toLowerCase() && (
                                                        <button
                                                            type="button"
                                                            className="btn wht-bg cross width-20"
                                                            onClick={() => this.adjustMapping()}
                                                        >
                                                            <svg
                                                                width="20"
                                                                height="20"
                                                                viewBox="0 0 20 20"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path d="M10.0003 13.3333C11.8387 13.3333 13.3337 11.8383 13.3337 9.99996C13.3337 8.16163 11.8387 6.66663 10.0003 6.66663C8.16199 6.66663 6.66699 8.16163 6.66699 9.99996C6.66699 11.8383 8.16199 13.3333 10.0003 13.3333ZM10.0003 8.33329C10.9037 8.33329 11.667 9.09663 11.667 9.99996C11.667 10.9033 10.9037 11.6666 10.0003 11.6666C9.09699 11.6666 8.33366 10.9033 8.33366 9.99996C8.33366 9.09663 9.09699 8.33329 10.0003 8.33329Z" />
                                                                <path d="M2.37086 13.4466L3.20419 14.8883C3.64669 15.6525 4.71169 15.9391 5.47919 15.4966L5.92003 15.2416C6.40503 15.6225 6.93753 15.935 7.50003 16.1683V16.6666C7.50003 17.5858 8.24753 18.3333 9.16669 18.3333H10.8334C11.7525 18.3333 12.5 17.5858 12.5 16.6666V16.1683C13.0625 15.935 13.595 15.6225 14.08 15.2425L14.5209 15.4975C15.29 15.9391 16.3525 15.6541 16.7967 14.8883L17.6292 13.4475C18.0892 12.6516 17.8159 11.63 17.02 11.1708L16.5992 10.9275C16.6442 10.6183 16.6667 10.3091 16.6667 9.99996C16.6667 9.69079 16.6442 9.38079 16.5992 9.07413L17.02 8.83079C17.8159 8.37079 18.0892 7.34996 17.6292 6.55413L16.7967 5.11329C16.3542 4.34663 15.29 4.05913 14.5209 4.50329L14.08 4.75829C13.595 4.37746 13.0625 4.06496 12.5 3.83163V3.33329C12.5 2.41413 11.7525 1.66663 10.8334 1.66663H9.16669C8.24753 1.66663 7.50003 2.41413 7.50003 3.33329V3.83163C6.93753 4.06496 6.40503 4.37746 5.92003 4.75746L5.47919 4.50246C4.70919 4.05996 3.64586 4.34663 3.20336 5.11246L2.37086 6.55329C1.91086 7.34913 2.18419 8.37079 2.98003 8.82996L3.40086 9.07329C3.35586 9.38079 3.33336 9.69079 3.33336 9.99996C3.33336 10.3091 3.35586 10.6183 3.40086 10.9258L2.98003 11.1691C2.18419 11.6291 1.91086 12.6508 2.37086 13.4466ZM5.14253 11.1483C5.04836 10.7708 5.00003 10.3841 5.00003 9.99996C5.00003 9.61496 5.04836 9.22829 5.14169 8.85163C5.23169 8.49079 5.07253 8.11413 4.75003 7.92829L3.81419 7.38663L4.64586 5.94579L5.60003 6.49746C5.92003 6.68163 6.32253 6.63496 6.59003 6.37913C7.15919 5.83996 7.84586 5.43663 8.57669 5.21329C8.92753 5.10663 9.16669 4.78246 9.16669 4.41663V3.33329H10.8334V4.41663C10.8334 4.78246 11.0725 5.10663 11.4234 5.21329C12.1542 5.43746 12.8409 5.83996 13.41 6.37913C13.6775 6.63496 14.0817 6.68079 14.4 6.49746L15.3534 5.94663L16.1867 7.38746L15.25 7.92829C14.9275 8.11496 14.7684 8.49163 14.8584 8.85163C14.9517 9.22829 15 9.61496 15 9.99996C15 10.3841 14.9517 10.7708 14.8575 11.1483C14.7684 11.5091 14.9275 11.8858 15.25 12.0716L16.1859 12.6125L15.3542 14.0533L14.4 13.5025C14.0809 13.3183 13.6775 13.3641 13.41 13.6208C12.8409 14.16 12.1542 14.5633 11.4234 14.7866C11.0725 14.8933 10.8334 15.2175 10.8334 15.5833L10.835 16.6666H9.16669V15.5833C9.16669 15.2175 8.92753 14.8933 8.57669 14.7866C7.84586 14.5625 7.15919 14.16 6.59003 13.6208C6.43169 13.4691 6.22503 13.3916 6.01669 13.3916C5.87336 13.3916 5.73003 13.4283 5.60003 13.5033L4.64669 14.055L3.81336 12.6141L4.75003 12.0716C5.07253 11.8858 5.23169 11.5091 5.14253 11.1483Z" />
                                                            </svg>
                                                        </button>
                                                    )}
                                                <button
                                                    type="button"
                                                    className="btn wht-bg cross width-12"
                                                    onClick={this.OpenViewer}
                                                >
                                                    <svg
                                                        width="12"
                                                        height="12"
                                                        viewBox="0 0 12 12"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="all-file-selector">
                                            {this.props.parentState.PageType !== "workOrderDetails" && (
                                                <Form.Check
                                                    custom
                                                    type="checkbox"
                                                    key={"all-file-selector"}
                                                    id={"all-file-selector"}
                                                    label={"Select All Pages"}
                                                    onChange={(e: any) => this.handleAllCheckbox(e)}
                                                    ref={this.footerchk}
                                                    disabled={!isPdfFile || this.props.parentState.PageType === "workOrderDetails"}
                                                />
                                            )}
                                        </div>
                                    </div>

                                    <ScrollContainer
                                        className={`scroll-area update-scroll ${this.state.modalOpen === "yes" ? "modal-open" : ""
                                            } ${currentView !== "doc-view" ? "grid-sec" : "doc-sec"} ${this.state.chkIds.length > 0 ? "footer-show" : ""
                                            }`}
                                        ref={this.scrollheight}
                                        hideScrollbars={false}
                                    >
                                        <>
                                            {this.state.filteredFiles.map((file: any, i: any) => {
                                                const fileType = file.name.split('.').pop().toLowerCase();


                                                return (
                                                    <div
                                                        id={`sec_${file.fileUniqueno}`}
                                                        className={
                                                            this.state.bulkSelect ? "footer-enable" : ""
                                                        }
                                                    >
                                                        <div
                                                            className={
                                                                currentView !== "doc-view"
                                                                    ? "grid-sec"
                                                                    : "doc-sec"
                                                            }
                                                        >
                                                            {this.state.defaultView == "grid-view" && (
                                                                <div className="custom-grid-header d-flex align-items-center">
                                                                    <div className="page-ttl">{file.name}</div>
                                                                </div>
                                                            )}

                                                            {((fileType) === "png" || (fileType) === "jpg" || (fileType) === "jpeg" || (fileType) === "bmp") ? (
                                                                <MyImage
                                                                    src={file.fileCode}
                                                                    fallbackSrc={file.fileCode}
                                                                    zoom={this.state.currentZoom}
                                                                />
                                                            )
                                                                : (
                                                                    <PDFViewer
                                                                        ref={this[`myRef${i}`]}
                                                                        scrollAreaHeight={this.state.scrollAreaHeight}
                                                                        isModalOpen={this["isModalOpen"]}
                                                                        uniqueno={file.uniqueNo}
                                                                        filePreview={file.fileCode}
                                                                        defaultView={currentView}
                                                                        fileNo={file.fileUniqueno}
                                                                        fileCount={savedfilesCount}
                                                                        fileName={file.name}
                                                                        docFile={allsavedfiles}
                                                                        updateState={handleUpdate}
                                                                        updateFiles={handleUpdateFiles}
                                                                        showBulkSelect={showBulkSelect}
                                                                        checkBulkSelect={checkBulkSelect}
                                                                        handleFileCheckBox={this["handleFileCheckBox"]}
                                                                        handleUpdatedFile={this["handleUpdatedFile"]}
                                                                        handleincompleteFile={this["handleincompleteFile"]}
                                                                        saveSplitFile={this["saveSplitFile"]}
                                                                        pageType={this.props.parentState.PageType}
                                                                        handleRotate={this["handleRotate"]}
                                                                        handlePageRemove={this["handlePageRemove"]}
                                                                        selectedChk={this.state.selectedChk}
                                                                        selectedZoom={this.state.currentZoom}
                                                                        setTotalPages={this["setTotalPages"]}
                                                                        isEditPermission={this.props.parentState.workorderPermission === "Yes"}
                                                                    />
                                                                )}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </>
                                    </ScrollContainer>
                                </div>
                            )}
                            <div className={`slideout-UI ${this.props.slideOutOpen ? "opened" : ""}`}>
                                <div className="wrapper">
                                    <div className="slideout-header edit-input-style" ref={this.parentScroll}>
                                        {this.props.parentState.PageType === "workOrderDetails" ?
                                            // <EllipsisWithTooltip><h3 className="heading">{this.state.parentRowData.name}</h3></EllipsisWithTooltip>
                                            <div className="pos-ttl mr-auto">
                                                <OverlayTrigger
                                                    placement="bottom"
                                                    defaultShow={false}
                                                    delay={{ show: 250, hide: 400 }}
                                                    overlay={
                                                        <Tooltip id={"Asset-Name"} className={name?.length <= 75 ? "tootltip-hide" : ""}>
                                                            {name}
                                                        </Tooltip>
                                                    }
                                                >
                                                    <AutosizeInput
                                                        ref={this.input}
                                                        className={`form-control removeBorder input-component ${this.state.bdrValue ? this.state.nameError ? "bdr-green" : "bdr-green" : ""}`}
                                                        style={{ fontSize: 24 }}
                                                        injectStyles={false}
                                                        type="input"
                                                        value={name}
                                                        tabIndex={1}
                                                        onClick={() => this.handleClick()}
                                                        onChange={(e: any) => {
                                                            this.onFieldChange(
                                                                Utils.BuildCustomEventObject(
                                                                    "name",
                                                                    e.target.value
                                                                ),
                                                                1
                                                            )
                                                        }
                                                        }
                                                        onBlur={() => this.handleBlurAutoSize()}
                                                        placeholder={"Enter Work Order Name"}
                                                        maxLength={100}
                                                    />
                                                </OverlayTrigger>


                                            </div>
                                            :
                                            <div className="user-details align-items-center mr-auto">
                                                <div className="location-title">{this.state.parentRowData.title}</div>
                                                <div className="position-name">Work Order</div>
                                            </div>
                                        }

                                        {this.props.parentState.PageType === "workOrderDetails" ?
                                            <div className="d-flex">
                                                {/* <Dropdown className="more-action" alignRight>
                                    <Dropdown.Toggle
                                        className="btn-outline-primary btn btn-primary more border-0 p-2"
                                        id="dropdown-more"
                                    >
                                        <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        >
                                        <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                                        <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                                        <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                                        </svg>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item
                                        onClick={() => this.handleExport()}
                                        >Export</Dropdown.Item>
                                    </Dropdown.Menu>
                                    </Dropdown> */}

                                                <Button className="pl-2" onClick={() => this.closeSlideOut("Buttonclick")}><FontAwesomeIcon icon={faClose} /></Button>
                                            </div>
                                            :
                                            <Button onClick={() => this.hideApprovalModal("", "closebtnclick")}><FontAwesomeIcon icon={faClose} /></Button>}
                                    </div>
                                    <div className={`slideout-body ${this.state.changeValue && "bottom-spacer"} `}>
                                    <Container
              fluid
              ref={this.slideoutRef} style={{padding: "0"}}
            >    
                                        <h3 className="label">Status</h3>
                                        <div className="buttons-wrapper">
                                            <div className="status-list">
                                                <button ref={this.btnOpen} onClick={() => this.updateWorkOrderStatus("Open")} className={this.props.parentState.PageType === "workOrderDetails" ? this.state.parentRowData.status === "Open" ? "active" : "" : this.state.tempLocationSlideOutStatus === "Open" ? "active" : ""} disabled={this.props.parentState.workorderPermission === "No"}>
                                                    <div className="circle"></div>
                                                    <span>Open</span>
                                                </button>
                                                <button ref={this.btnInprogress} onClick={() => this.updateWorkOrderStatus("In Progress")} className={this.props.parentState.PageType === "workOrderDetails" ? this.state.parentRowData.status === "In Progress" ? "active" : "" : this.state.tempLocationSlideOutStatus === "In Progress" ? "active" : ""} disabled={this.props.parentState.workorderPermission === "No"}>
                                                    <FontAwesomeIcon icon={faPlay} />
                                                    <span>In Progress</span>
                                                </button>
                                                <button ref={this.btnOnhold} onClick={() => this.updateWorkOrderStatus("On Hold")} className={this.props.parentState.PageType === "workOrderDetails" ? this.state.parentRowData.status === "On Hold" ? "active" : "" : this.state.tempLocationSlideOutStatus === "On Hold" ? "active" : ""} disabled={this.props.parentState.workorderPermission === "No"}>
                                                    <FontAwesomeIcon icon={faPause} />
                                                    <span>On Hold</span>
                                                </button>
                                                <button ref={this.btnComplet} onClick={() => this.updateWorkOrderStatus("Completed")} className={this.props.parentState.PageType === "workOrderDetails" ? this.state.parentRowData.status === "Completed" ? "active" : "" : this.state.tempLocationSlideOutStatus === "Completed" ? "active" : ""} disabled={this.props.parentState.workorderPermission === "No"}>
                                                    <FontAwesomeIcon icon={faCheck} />
                                                    <span>Complete</span>
                                                </button>
                                                {this.state.isOpenWorkOrderCompleteModal && (
                                                    <CompleteWorkOrderModal
                                                        isOpen={this.state.isOpenWorkOrderCompleteModal}
                                                        isDataSaving={this.state.isDataSaving}
                                                        onClose={() => this.closeDialog()}
                                                        onSave={(data) => { this.saveWorkOrderStatus("Completed", data); this.setState({ isDataSaving: true }) }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                        <div className="order-info">
                                            <Form.Group controlId="location" className="location-dropdown">
                                                <Form.Label>Location</Form.Label>
                                                {this.state.locationList.length > 0 && (

                                                    <SingleSearchDropdownList
                                                        // // isdisable={this.props.locationDisable}
                                                        isRefresh={this.state.isRefresh}
                                                        itemList={this.state.locationList}
                                                        handleSelectedItem={this.handleSelectedItem.bind(
                                                            this,
                                                            4
                                                        )}
                                                        defaultItem={this.state.locationList}
                                                        defaultText={"Location"}
                                                       // defaultName={this.state.locationList.filter((item) => item.id === this.state.parentRowData.locationID)[0]?.name}
                                                       
                                                       defaultName={this.state.locationList.filter((item) => item.id === (this.state.discardLocationId == 0 ? Number(this.state.parentRowData.locationID) : Number(this.state.discardLocationId)))[0]?.name}
                                                        controlID="4"
                                                        isdisable={this.props.parentState.PageType === "locationWorkOrder" || this.props.parentState.workorderPermission === "No" ? true : false}
                                                    />
                                                )}
                                            </Form.Group>
                                            <Form.Group controlId="asset" className="asset-row">
                                                <Form.Label>Asset</Form.Label>

                                                {/* {this.state.assetList.length > 0 && (


                                            // <SingleSearchDropdownList
                                            //     isdisable={this.props.assetDisable ||this.props.parentState.workorderPermission === "No"}
                                            //     isRefresh={this.state.isRefresh}
                                            //     itemList={this.state.assetList}
                                            //     handleSelectedItem={this.handleSelectedItem.bind(
                                            //         this,
                                            //         3
                                            //     )}
                                            //     defaultItem={this.state.assetList}
                                            //     defaultText={"Search Asset"}
                                            //     defaultName={(this.state.assetList.filter((item) => item.id === this.state.parentRowData.assetID))[0]?.name === undefined ? "Select an asset" :
                                            //         (this.state.assetList.filter((item) => item.id === this.state.parentRowData.assetID))[0]?.name}

                                            //     controlID="3"
                                            // />
                                              )} */}
                                                <MultiSelectAssetType
                                                    ref={this.multySelect}
                                                    assetList={this.state.assetList}
                                                    assetSelectedValue={this.assetSelectedValue}
                                                    selectedAssetsId={this.state.discradAssetId === "" ? this.state.assetID : this.state.discradAssetId}
                                                    assetSelectedLocationValue={this.assetSelectedLocationValue}
                                                />



                                            </Form.Group>
                                            <Form.Group controlId="priority" className="priority-dropdown">
                                                <Form.Label>Priority</Form.Label>
                                                <div className="priority-input">
                                                    {/* <Form.Control type="text" value="Medium" />
                                    <div className="priority Medium"></div>  */}

                                                    {this.state.priorityList.length > 0 && (
                                                        <SingleSearchDropdownList
                                                            id={"tabletypeddl"}
                                                            isRefresh={this.state.isRefresh}
                                                            itemList={this.state.priorityList}
                                                            handleSelectedItem={this.handleSelectedItem.bind(
                                                                this,
                                                                2
                                                            )}
                                                            allowSearch={false}
                                                            defaultItem={this.state.priorityList}
                                                            defaultText={"Search Status"}
                                                            defaultName={this.state.parentRowData.priorityType}
                                                            controlID="2"
                                                            isShowPip={true}
                                                            isdisable={this.props.parentState.workorderPermission === "No"}
                                                        />
                                                    )}


                                                </div>
                                            </Form.Group>
                                            <Form.Group controlId="dueDate">
                                                <Form.Label>Due Date</Form.Label>
                                                <DatePicker
                                                    value={this.state.selectedDueDate ? new Date(this.state.selectedDueDate) : null}
                                                    name="startDate"
                                                    //className={`form-control scheduleInput ${row.isDuplicateEntry ? "alert-danger" : ''}`}
                                                    id="shiftStartDate"
                                                    selected={this.state.selectedDueDate ? new Date(this.state.selectedDueDate) : null}
                                                    onSelect={(e: any) => this.handleSelectDate(e, "startDate", "")}
                                                    onChange={(e: any) => this.handleSelectDate(e, "startDate", "onChange")}
                                                    autoComplete="off"
                                                    placeholderText="Set due date"
                                                    disabled={this.props.parentState.workorderPermission === "No"}

                                                />
                                            </Form.Group>
                                            <Form.Group controlId="assignedTo" className="assigned-to-dropdow">
                                                <Form.Label>Assigned To</Form.Label>

                                                {this.props.parentState.assignToList.length > 0 && (

                                                    <SingleSearchDropdownList
                                                        isRefresh={this.state.isRefresh}
                                                        itemList={this.state.assignToList}
                                                        handleSelectedItem={this.handleSelectedItem.bind(
                                                            this,
                                                            1
                                                        )}
                                                        defaultItem={this.state.assignToList}
                                                        defaultText={"Assigned To"}
                                                        // defaultName={this.state.assignToList.filter((item) => item.id === this.state.parentRowData.user_UniqueID)[0]?.name}
                                                        defaultName={(this.state.assignToList.filter((item) => item.id === this.state.parentRowData.user_UniqueID))[0]?.name === undefined ? "Select a technician" :
                                                            (this.state.assignToList.filter((item) => item.id === this.state.parentRowData.user_UniqueID))[0]?.name}

                                                        controlID="1"
                                                        isdisable={this.props.parentState.workorderPermission === "No"}
                                                    />
                                                )}
                                            </Form.Group>
                                        </div>
                                        <div className="py-4">
                                            <div className="description-box">
                                                <h5 className="label">Description <b>*</b></h5>
                                                <Form.Group onBlur={() => this.validationOnClick(5)} controlId="description" className="d-flex">

                                                    <Col
                                                        sm={"12"}
                                                        className={`mb-0 p-0 ${this.state.errors ? "validation-error" : ""
                                                            }`}
                                                        onClick={() => this.validationOnClick(5)}
                                                    >
                                                        <Form.Control
                                                            as="textarea"
                                                            type="textarea"
                                                            className="form-control"
                                                            //maxLength={250}
                                                            id="description"
                                                            name="description"
                                                            autoComplete="description"
                                                            value={this.state.description}
                                                            placeholder="Give as much detail as possible about the problem, location and anything else relevant"
                                                            onChange={(e) => this.descriptionChange(e)}
                                                            disabled={this.props.parentState.workorderPermission === "No"}

                                                        //  onBlur={()=>{this.setState({description:{...this.state.description}})}}
                                                        // onBlur={(e) => this.descriptionChange(e)}
                                                        />
                                                    </Col>
                                                </Form.Group>

                                            </div>
                                            <div className="mb-3">
                                                <h5 className="label mb-1">Submitter</h5>
                                                <h6 className="body-font">{this.state.parentRowData?.createdBy}</h6>
                                            </div>
                                        </div>

                                        <div className={`filter-sec upload-section ${this.props.parentState.workorderPermission === "No" ? "disabled" : ""}`}>


                                            <Form.Group controlId="exampleForm.ControlTextarea1" >
                                                <div className="d-flex">
                                                    <Form.Label className="mr-auto label">Attachments</Form.Label>
                                                    {/* {this.state.savedfiles.length > 0 && (
                                                <div className="upload-link">
                                                    <button type="button" className="btn wht-bg link-btn mr-auto" onClick={this.OpenViewer}>
                                                                {this.state.isOpenViewer ? 'Close Viewer' : 'Open Viewer'}
                                                            </button> 
                                                </div>
                                            )} */}
                                                </div>
                                                <div>

                                                    <Dropzone
                                                        // disabled={isBedgeProcessing}
                                                        disabled={this.props.parentState.workorderPermission === "No"}
                                                        onDrop={this.onDrop}
                                                    // accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml"
                                                    >
                                                        {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
                                                            <>
                                                                <section className={isDragActive ? "container upload-area default drag-active " : "container upload-area default"}>

                                                                    {!this.state.bulkSelect && (

                                                                        <div {...getRootProps({
                                                                            className: 'dropzone d-flex align-items-center',
                                                                            onClick: (this.state.newSelectfiles.length > 0 || this.state.savedfiles.length > 0) ?
                                                                                event => event.stopPropagation() : event => event
                                                                        })}>
                                                                            <input {...getInputProps()} />
                                                                            {(this.state.newSelectfiles.length < 1 && this.state.savedfiles.length < 1) && (
                                                                                <p>Drag and drop files or <span>browse files</span> to upload.</p>
                                                                            )}
                                                                            {(this.state.newSelectfiles.length > 0 || this.state.savedfiles.length > 0) && isDragActive && (
                                                                                <p>Drag and drop files here to upload.</p>
                                                                            )}
                                                                            {/* {!isDragActive && (<p>Drag and drop or <span>browse files</span> to upload</p>)} */}

                                                                        </div>

                                                                    )}

                                                                    {/* {this.state.bulkSelect && ( 
                                                                        <div className="dropzone d-flex align-items-center">
                                                                            <p>Drag and drop or <span>browse files</span> to upload</p>
                                                                        </div>
                                                                   )}   */}
                                                                    {(this.state.newSelectfiles.length > 0 || this.state.savedfiles.length > 0) && (
                                                                        <aside className="d-flex flex-column">
                                                                            <ul className="p-0">{files1}</ul>
                                                                            <ul className="p-0">{files}</ul>
                                                                        </aside>
                                                                    )}
                                                                </section>
                                                                {(!this.state.bulkSelect && (this.state.newSelectfiles.length > 0 || this.state.savedfiles.length > 0) && this.props.parentState.workorderPermission === "Yes") && (
                                                                    <div className="upload-link mrgn-top">
                                                                        <button type="button" className="btn p-0 wht-bg link-btn mr-auto" >Add Attachment</button>
                                                                        <Form.Control id="formControlsFile" type="file" multiple onChange={(event: any) => this.onFileChange(event, "1")} disabled={this.props.parentState.workorderPermission === "No"}
                                                                            accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml" />

                                                                    </div>
                                                                )}
                                                            </>
                                                        )}
                                                    </Dropzone>
                                                </div>
                                            </Form.Group>


                                        </div>


                                        <div className="comments text-break position-relative" ref={this.anotherRef} style={{height: this.state.activeTab === "History" ? '100vh' : ''}}>
                                            <Tabs defaultActiveKey="Comments" onSelect={this.handleTabChange}>
                                                <Tab eventKey="Comments" title="Comments" className="comments_tab">
                                                    {/* <div className="add-comment">
                                                <img src={profile} className="user" alt="user" />
                                                <Form.Control type="text" placeholder="Write a comment..." />
                                            </div> */}
                                                    {/* <div className={this.props.parentState.workorderPermission === "No" ? "comment-disabled" : ""}> */}
                                                    <div>

                                                        <AddCommentBox
                                                            ref={this.ChildComment}
                                                            hotelid={this.state.parentRowData?.hid}
                                                            workOrderId={Number(this.state.parentRowData?.workOrderID)}
                                                            entryType={this.props.pageType}
                                                            //  uniqueNo={this.state.formData.actionType === "copy" ? 0 : this.props.pageType === "Invoice" ? this.state.formData.uniqueno : this.state.formData.incompleteUniqueno}
                                                            precommentlist={this.state.htmlcomment}
                                                            parentScrollMethod={this.scrollToBottom}
                                                            updatedCommentItem={this.updatedCommentItem}
                                                            handleCommentsSaved={this.handleCommentsSaved}
                                                            parentState={this.state}
                                                        />

                                                    </div>

                                                </Tab>
                                                <Tab eventKey="History" title="History" className="history_tab">
                                                    <div className="justify-content-between">
                                                        <div className="Export-link mrgn-top">
                                                            <button type="button" className="btn p-0 wht-bg link-btn mr-auto" onClick={this.handleExport} >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 16 18" fill="none">
                                                                    <path d="M15 6H11V0H5V6H1L8 14L15 6ZM0 16H16V18H0V16Z" fill="#2CAF92" />
                                                                </svg>
                                                                Export</button>
                                                        </div>
                                                        {this.state.activeTab === "History" &&
                                                            <AddHistoryBox
                                                                ref={(ref) => (this.childHistoryBox = ref)}
                                                                hotelid={this.state.parentRowData?.hid}
                                                                workOrderId={Number(this.state.parentRowData?.workOrderID)}
                                                                entryType={this.props.pageType}
                                                                //  uniqueNo={this.state.formData.actionType === "copy" ? 0 : this.props.pageType === "Invoice" ? this.state.formData.uniqueno : this.state.formData.incompleteUniqueno}
                                                                precommentlist={this.state.htmlHistory}
                                                                parentScrollMethod={this.scrollToBottom}
                                                                updatedCommentItem={this.updatedCommentItem}
                                                                parentState={this.state}
                                                            />

                                                        }
                                                        

                                                    </div>

                                                </Tab>
                                            </Tabs>

                                        </div>
                                        </Container>
                                    </div>



                                    {this.props.parentState.workorderPermission === "Yes" && (
                                        <div>
                                            {
                                                this.state.changeValue && <div className=" footer-section fixed-action px-3 pb-2 h-auto">
                                                    <div className="d-flex align-items-center flex-wrap forecast-action-strip">

                                                        <div className="mr-auto message">
                                                            <span>You have made changes to the current work order. <br /> Would you like to save and continue?</span>
                                                        </div>

                                                        <button
                                                            type="button"
                                                            className="btn btn-primary border-0 btn-discard btn-changes-discard"
                                                            onClick={() => this.disccardChanges("discardButton")}
                                                        >
                                                            Discard
                                                        </button>


                                                        <button
                                                            ref={this.btnSave}
                                                            type="button"
                                                            className="save-btn btn btn-primary mr-0"
                                                            onClick={this.handleSave}
                                                        >
                                                            Save & Continue
                                                        </button>

                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>
                </OutsideClickHandler>
            </>
        );
    }

}


